// Documento de reporte (descarga .html / impresion): porteo del componente
// Dictamen de sigte-prototipo.jsx:1595-1913 (portada, hoja 2, resumen
// ejecutivo, checklist, hallazgos, evidencia, firmas) a una plantilla de
// string. Es un documento aparte de la pantalla de la app -- usa el lenguaje
// visual del prototipo (neutral-XXX, badges de color), no el azul de SIGTE.
//
// La "portada" del prototipo (PORTADA_INICIAL, linea 294) es configurable por
// tenant via PortadaConfig -- aqui es fija (texto/color/logo de SIGTE
// codificados), mismo criterio que ya se aplico al logo global: nada
// per-empresa en este documento.
//
// Todo el CSS es plano (sin Tailwind ni CDN externo) para que el archivo
// exportado sea autocontenido y se vea igual sin conexion a internet, meses
// despues de generado.

var CHECKLIST_PUNTOS = ["Cabina", "Puertas", "Guías", "Motor", "Variador", "Freno", "UPS",
  "Polea", "Sensores", "Iluminación", "Comunicación", "Alarmas", "Cuarto de máquinas"];

var SIGTE_BRAND = "#0F2C70";

var CALIFICACIONES_LABELS = {
  mantenimiento: {
    C: { label: "Conforme", bg: "#ecfdf5", color: "#047857" },
    NC: { label: "No conforme", bg: "#fef2f2", color: "#b91c1c" },
    NA: { label: "No aplica", bg: "#f5f5f5", color: "#737373" },
    OBS: { label: "Con observaciones", bg: "#fffbeb", color: "#b45309" },
  },
  supervision: {
    C: { label: "Cumple", bg: "#ecfdf5", color: "#047857" },
    NC: { label: "No cumple", bg: "#fef2f2", color: "#b91c1c" },
    NA: { label: "No aplica", bg: "#f5f5f5", color: "#737373" },
    OBS: { label: "Con observación", bg: "#fffbeb", color: "#b45309" },
  },
};
var RIESGO_ESTILO = {
  "Crítico": { bg: "#fef2f2", color: "#b91c1c", border: "#fecaca" },
  "Alto": { bg: "#fff7ed", color: "#c2410c", border: "#fed7aa" },
  "Medio": { bg: "#fffbeb", color: "#b45309", border: "#fde68a" },
  "Bajo": { bg: "#ecfdf5", color: "#047857", border: "#a7f3d0" },
};

var ICONOS_FEATURE = [
  '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><rect x="6" y="4" width="12" height="16" rx="2"/><path d="M9 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1"/><path d="m9 13 2 2 4-4"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M12 2 4 5v6c0 5 3.5 8.5 8 11 4.5-2.5 8-6 8-11V5z"/></svg>',
  '<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L2 19l3 3 7.3-7.3a4 4 0 0 0 5.4-5.4l-2.8 2.8-2-2z"/></svg>',
];

var PORTADA = {
  empresaNombre: "SIGTE",
  empresaEslogan: "SISTEMA INTEGRAL DE GESTIÓN TÉCNICA DE ELEVADORES",
  descripcion: "Inspección, verificación y seguimiento del correcto funcionamiento y condiciones de operación.",
  features: [
    { titulo: "Inspección", descripcion: "Evaluación técnica y verificación" },
    { titulo: "Seguridad", descripcion: "Cumplimiento normativo y buenas prácticas" },
    { titulo: "Desempeño", descripcion: "Análisis y seguimiento de condiciones" },
  ],
  colorPrimario: SIGTE_BRAND,
  sitioWeb: "kofides.com",
  tagline: "SEGURIDAD · CONFIABILIDAD · CALIDAD",
};

function escapeHtml(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}

function ordenarChecklist(items) {
  var porPunto = {};
  (items || []).forEach(function (it) { porPunto[it.punto] = it; });
  return CHECKLIST_PUNTOS.map(function (pt) { return porPunto[pt] || { punto: pt, calificacion: null, observacion: null }; });
}

function citaLabel(normasMap, citaId) {
  var c = normasMap[citaId];
  if (!c) return null;
  return c.documento_codigo + ", " + c.numeral + " — " + c.titulo;
}

function fraseCalificacion(porcentaje, esSupervision) {
  if (porcentaje === null || porcentaje === undefined) return "Sin calificar";
  return (esSupervision ? "Cumple" : "Conforme") + " en un " + porcentaje + "%";
}

function fotosImg(fotos, dataUrls, size) {
  return (fotos || []).map(function (f) {
    return dataUrls[f] ? '<img class="foto-mini" style="width:' + size + 'px;height:' + size + 'px;" src="' + dataUrls[f] + '" alt=""/>' : "";
  }).join("");
}

function resumenEjecutivo(d, checklist, esSupervision, nc, criticos) {
  var interno = escapeHtml(d.equipo_interno || "");
  var partes = [];
  partes.push(esSupervision
    ? "Se supervisó el mantenimiento preventivo del equipo " + interno + " conforme al programa mensual."
    : "Se realizó la inspección de mantenimiento preventivo del equipo " + interno + " conforme al programa mensual.");
  partes.push("De " + checklist.length + " puntos " + (esSupervision ? "revisados" : "verificados") + ", " +
    (checklist.length - nc) + " " + (esSupervision ? "cumplieron" : "resultaron conformes") + " y " + nc + " " +
    (esSupervision ? "no cumplieron" : "no conforme" + (nc === 1 ? "" : "s")) + ".");
  var hallazgosTxt = "Se documentaron " + (d.hallazgos || []).length + " hallazgo" + ((d.hallazgos || []).length === 1 ? "" : "s");
  if (criticos > 0) {
    hallazgosTxt += ", de los cuales " + criticos + " " + (criticos === 1 ? "es crítico y requiere" : "son críticos y requieren") + " atención inmediata";
  }
  partes.push(hallazgosTxt + ".");
  return partes.join(" ");
}

export function construirReporteHtml(d, normasMap, dataUrls, logoDataUrl) {
  var esSupervision = d.tipo_reporte === "supervision";
  var checklist = ordenarChecklist(d.checklist);
  var calificaciones = CALIFICACIONES_LABELS[esSupervision ? "supervision" : "mantenimiento"];
  var nc = checklist.filter(function (it) { return it.calificacion === "NC"; }).length;
  var criticos = (d.hallazgos || []).filter(function (h) { return h.riesgo === "Crítico"; }).length;
  var porcentaje = d.calificacion_pct != null ? d.calificacion_pct : null;
  var cfgGeneral = calificaciones[d.calificacion_tier] || { bg: "#f5f5f5", color: "#a3a3a3" };
  var tituloReporte = esSupervision ? "REPORTE DE SUPERVISIÓN" : "DICTAMEN TÉCNICO";
  var numFirmas = esSupervision ? 2 : 3;
  var equipoSub = [d.equipo_marca, d.equipo_modelo].filter(Boolean).join(" ");
  if (d.equipo_tipo) equipoSub = equipoSub ? equipoSub + " · " + d.equipo_tipo : d.equipo_tipo;
  if (!equipoSub) equipoSub = "—";

  var featuresHtml = PORTADA.features.map(function (f, i) {
    return '<div class="feature">' +
      '<div class="feature-icon" style="background-color:' + PORTADA.colorPrimario + ';">' + ICONOS_FEATURE[i % ICONOS_FEATURE.length] + '</div>' +
      '<div><p class="feature-titulo">' + escapeHtml(f.titulo) + '</p><p class="feature-desc">' + escapeHtml(f.descripcion) + '</p></div>' +
      '</div>';
  }).join("");

  var checklistHtml = checklist.map(function (it) {
    var cfg = calificaciones[it.calificacion] || { label: "Sin registrar", bg: "#f5f5f5", color: "#a3a3a3" };
    return '<li class="checklist-item">' +
      '<div class="checklist-row"><span class="checklist-punto">' + escapeHtml(it.punto) + '</span>' +
      '<span class="badge" style="background:' + cfg.bg + ';color:' + cfg.color + ';">' + escapeHtml(cfg.label) + '</span></div>' +
      (it.observacion ? '<p class="checklist-obs">' + escapeHtml(it.observacion) + '</p>' : "") +
      '</li>';
  }).join("");

  var hallazgosHtml = (d.hallazgos || []).length === 0
    ? '<p class="vacio">Sin hallazgos registrados durante la inspección.</p>'
    : '<ol class="hallazgos-lista">' + (d.hallazgos || []).map(function (h, i) {
        var cita = citaLabel(normasMap, h.cita_id);
        var riesgo = RIESGO_ESTILO[h.riesgo] || RIESGO_ESTILO["Bajo"];
        var fotos = fotosImg(h.fotos, dataUrls, 72);
        return '<li class="hallazgo">' +
          '<span class="hallazgo-num">' + String(i + 1).padStart(2, "0") + '</span>' +
          '<div class="hallazgo-body">' +
            '<div class="hallazgo-tags">' +
              (h.categoria ? '<span class="tag-categoria">' + escapeHtml(h.categoria) + '</span>' : "") +
              '<span class="badge badge-border" style="background:' + riesgo.bg + ';color:' + riesgo.color + ';border-color:' + riesgo.border + ';">' + escapeHtml(h.riesgo) + '</span>' +
            '</div>' +
            '<p class="hallazgo-desc">' + escapeHtml(h.descripcion) + '</p>' +
            '<p class="hallazgo-meta"><span class="meta-label">Recomendación:</span> ' + escapeHtml(h.recomendacion || "—") + ' · ' + escapeHtml(h.tiempo || "—") + '</p>' +
            (cita ? '<p class="hallazgo-norma">' + escapeHtml(cita) + '</p>' : "") +
            (fotos ? '<div class="fotos-row">' + fotos + '</div>' : "") +
          '</div>' +
        '</li>';
      }).join("") + '</ol>';

  var fotosGeneralesHtml = fotosImg(d.fotos, dataUrls, 100);

  var firmasHtml = "";
  function firmaBox(archivo, titulo, nombre) {
    var img = archivo && dataUrls[archivo] ? '<img src="' + dataUrls[archivo] + '" alt="Firma de ' + escapeHtml(titulo) + '" class="firma-img"/>' : '<span class="firma-pendiente">Pendiente</span>';
    return '<div class="firma-box"><div class="firma-linea">' + img + '</div><p class="firma-titulo">' + escapeHtml(titulo) + '</p><p class="firma-nombre">' + escapeHtml(nombre || "—") + '</p></div>';
  }
  if (!esSupervision) firmasHtml += firmaBox(d.firma_tecnico_archivo, "Técnico", d.tecnico_nombre);
  firmasHtml += firmaBox(d.firma_supervisor_archivo, "Supervisor", d.supervisor_nombre);
  firmasHtml += firmaBox(d.firma_cliente_archivo, "Representante del cliente", d.representante_cliente);

  var logoHtml = logoDataUrl
    ? '<img src="' + logoDataUrl + '" alt="' + escapeHtml(PORTADA.empresaNombre) + '" class="portada-logo-img"/>'
    : '<div class="portada-logo-fallback" style="background-color:' + PORTADA.colorPrimario + ';">' + escapeHtml(PORTADA.empresaNombre[0]) + '</div>';

  var style = '' +
    '*{box-sizing:border-box;}' +
    'body{margin:0;padding:24px;background:#f5f5f5;font-family:-apple-system,BlinkMacSystemFont,\'Segoe UI\',Roboto,\'Helvetica Neue\',sans-serif;color:#171717;}' +
    '.documento{max-width:780px;margin:0 auto;overflow:hidden;border-radius:16px;border:1px solid #e5e5e5;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,0.08);}' +
    '.no-print-bar{max-width:780px;margin:0 auto 12px;text-align:right;}' +
    '.btn-imprimir{border:1px solid #d4d4d4;background:#fff;color:#404040;font-size:13px;font-weight:600;padding:8px 16px;border-radius:10px;cursor:pointer;}' +
    '.portada{position:relative;aspect-ratio:210/297;display:flex;flex-direction:column;justify-content:space-between;overflow:hidden;background:linear-gradient(160deg,#ffffff 55%,' + PORTADA.colorPrimario + '14 55%);}' +
    '.portada-top{padding:40px;}' +
    '.portada-marca{display:flex;align-items:center;gap:12px;}' +
    '.portada-logo-img{height:56px;width:56px;border-radius:12px;border:1px solid #f5f5f5;background:#fff;object-fit:contain;padding:6px;box-shadow:0 1px 2px rgba(0,0,0,0.08);}' +
    '.portada-logo-fallback{height:56px;width:56px;border-radius:12px;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:800;font-size:20px;}' +
    '.portada-empresa{font-size:20px;font-weight:800;line-height:1;letter-spacing:-0.02em;color:' + PORTADA.colorPrimario + ';margin:0;}' +
    '.portada-eslogan{margin:4px 0 0;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:0.1em;color:#737373;}' +
    '.portada-titulo{margin:36px 0 0;font-size:34px;font-weight:800;line-height:1.1;color:' + PORTADA.colorPrimario + ';}' +
    '.portada-subtitulo{margin:0;font-size:26px;font-weight:300;color:#a3a3a3;}' +
    '.portada-linea{margin-top:16px;height:4px;width:64px;border-radius:4px;background:' + PORTADA.colorPrimario + ';}' +
    '.portada-desc{margin-top:18px;max-width:340px;font-size:13px;line-height:1.6;color:#404040;}' +
    '.portada-features{margin-top:28px;display:flex;flex-direction:column;gap:14px;}' +
    '.feature{display:flex;align-items:flex-start;gap:10px;}' +
    '.feature-icon{flex-shrink:0;height:34px;width:34px;border-radius:9999px;display:flex;align-items:center;justify-content:center;}' +
    '.feature-titulo{margin:0;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.03em;color:#262626;}' +
    '.feature-desc{margin:1px 0 0;font-size:11px;color:#737373;}' +
    '.portada-footer-info{display:grid;grid-template-columns:repeat(3,1fr);border-top:1px solid rgba(229,229,229,0.7);background:rgba(255,255,255,0.9);font-size:11px;}' +
    '.portada-footer-info div{padding:14px 20px;border-top:1px solid rgba(229,229,229,0.7);}' +
    '.portada-footer-info div:nth-child(-n+3){border-top:none;}' +
    '.footer-label{margin:0;font-weight:600;letter-spacing:0.03em;color:#a3a3a3;}' +
    '.footer-value{margin:2px 0 0;color:#171717;}' +
    '.portada-tagline{padding:10px 40px;text-align:center;font-size:10px;font-weight:600;letter-spacing:0.15em;color:#fff;background:' + PORTADA.colorPrimario + ';}' +
    '.hoja2{border-bottom:4px solid #171717;padding:40px;}' +
    '.hoja2 .kicker{margin:0;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:0.1em;color:#a3a3a3;}' +
    '.hoja2 h2{margin:10px 0 0;font-size:28px;font-weight:700;letter-spacing:-0.02em;color:#171717;}' +
    '.hoja2 .sub{margin:4px 0 0;font-size:13px;color:#737373;}' +
    '.hoja2 dl{margin:28px 0 0;display:grid;grid-template-columns:repeat(2,1fr);gap:18px 24px;font-size:13px;}' +
    '.hoja2 dt{margin:0;font-size:11px;color:#a3a3a3;}' +
    '.hoja2 dd{margin:2px 0 0;color:#171717;}' +
    '.seccion{border-bottom:1px solid #f5f5f5;padding:28px 40px;}' +
    '.seccion:last-child{border-bottom:0;}' +
    '.kicker{margin:0;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:0.1em;color:#a3a3a3;}' +
    '.resumen-parrafo{margin:12px 0 0;font-size:13px;line-height:1.6;color:#404040;}' +
    '.resumen-stats{margin-top:18px;display:grid;grid-template-columns:repeat(3,1fr);gap:10px;}' +
    '.resumen-stat{border-radius:12px;background:#fafafa;padding:14px;text-align:center;}' +
    '.resumen-stat p:first-child{margin:0;font-size:22px;font-weight:700;color:#171717;}' +
    '.resumen-stat p:last-child{margin:2px 0 0;font-size:11px;color:#737373;}' +
    '.resumen-general{margin-top:10px;border-radius:12px;padding:14px;text-align:center;}' +
    '.resumen-general p:first-child{margin:0;font-size:16px;font-weight:700;}' +
    '.resumen-general p:last-child{margin:2px 0 0;font-size:11px;opacity:0.8;}' +
    '.checklist-lista{margin:16px 0 0;padding:0;list-style:none;display:grid;grid-template-columns:repeat(2,1fr);gap:0 24px;}' +
    '.checklist-item{border-bottom:1px dashed #f5f5f5;padding:6px 0;}' +
    '.checklist-row{display:flex;align-items:center;justify-content:space-between;gap:10px;}' +
    '.checklist-punto{font-size:13px;color:#404040;}' +
    '.checklist-obs{margin:2px 0 0;font-size:11px;color:#737373;}' +
    '.badge{flex-shrink:0;border-radius:9999px;padding:2px 10px;font-size:11px;font-weight:600;}' +
    '.badge-border{border:1px solid;}' +
    '.vacio{margin:12px 0 0;font-size:13px;color:#737373;}' +
    '.hallazgos-lista{margin:16px 0 0;padding:0;list-style:none;display:flex;flex-direction:column;gap:20px;}' +
    '.hallazgo{display:flex;gap:14px;}' +
    '.hallazgo-num{flex-shrink:0;font-size:14px;font-weight:700;color:#d4d4d4;}' +
    '.hallazgo-tags{display:flex;flex-wrap:wrap;align-items:center;gap:8px;}' +
    '.tag-categoria{border-radius:6px;background:#f5f5f5;padding:2px 8px;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:0.03em;color:#737373;}' +
    '.hallazgo-desc{margin:6px 0 0;font-size:13px;line-height:1.6;color:#404040;}' +
    '.hallazgo-meta{margin:6px 0 0;font-size:11px;color:#737373;}' +
    '.meta-label{font-weight:600;color:#404040;}' +
    '.hallazgo-norma{margin:4px 0 0;font-size:11px;color:#a3a3a3;}' +
    '.fotos-row{margin-top:8px;display:flex;flex-wrap:wrap;gap:8px;}' +
    '.foto-mini{object-fit:cover;border-radius:8px;border:1px solid #e5e5e5;}' +
    '.evidencia-grid{margin-top:16px;display:flex;flex-wrap:wrap;gap:10px;}' +
    '.firmas-grid{margin-top:16px;display:grid;gap:24px;grid-template-columns:repeat(' + numFirmas + ',1fr);}' +
    '.firma-box{text-align:center;}' +
    '.firma-linea{height:80px;display:flex;align-items:center;justify-content:center;border-bottom:1px solid #d4d4d4;}' +
    '.firma-img{max-height:64px;max-width:100%;}' +
    '.firma-pendiente{font-size:11px;color:#d4d4d4;}' +
    '.firma-titulo{margin:8px 0 0;font-size:11px;font-weight:600;color:#404040;}' +
    '.firma-nombre{margin:0;font-size:11px;color:#737373;}' +
    '.pie{margin:32px 0 0;text-align:center;font-size:10px;color:#a3a3a3;}' +
    '@media (max-width:640px){.hoja2 dl{grid-template-columns:repeat(2,1fr);}.resumen-stats{grid-template-columns:1fr;}.checklist-lista{grid-template-columns:1fr;}.firmas-grid{grid-template-columns:1fr;}.portada-footer-info{grid-template-columns:1fr;}.portada-footer-info div:nth-child(-n+3){border-top:1px solid rgba(229,229,229,0.7);}.portada-footer-info div:first-child{border-top:none;}}' +
    '@media print{' +
      'body{background:#fff;padding:0;}' +
      '.documento{max-width:none;border-radius:0;border:0;box-shadow:none;}' +
      '.portada{aspect-ratio:auto;min-height:277mm;}' +
      '.hoja2{page-break-before:always;}' +
      '.no-print,.no-print-bar{display:none !important;}' +
    '}' +
    '@page{size:A4;margin:12mm;}';

  return '<!doctype html><html lang="es"><head><meta charset="utf-8"/><meta name="viewport" content="width=device-width, initial-scale=1"/>' +
    '<title>' + escapeHtml(tituloReporte) + ' ' + escapeHtml(d.codigo) + '</title>' +
    '<style>' + style + '</style></head><body>' +
    '<div class="no-print-bar"><button class="btn-imprimir" onclick="window.print()">Imprimir este documento</button></div>' +
    '<div class="documento">' +
      '<div class="portada">' +
        '<div class="portada-top">' +
          '<div class="portada-marca">' + logoHtml +
            '<div><p class="portada-empresa">' + escapeHtml(PORTADA.empresaNombre) + '</p><p class="portada-eslogan">' + escapeHtml(PORTADA.empresaEslogan) + '</p></div>' +
          '</div>' +
          '<h1 class="portada-titulo">' + escapeHtml(tituloReporte) + '</h1>' +
          '<h2 class="portada-subtitulo">DE ELEVADORES</h2>' +
          '<div class="portada-linea"></div>' +
          '<p class="portada-desc">' + escapeHtml(PORTADA.descripcion) + '</p>' +
          '<div class="portada-features">' + featuresHtml + '</div>' +
        '</div>' +
        '<div>' +
          '<div class="portada-footer-info">' +
            '<div><p class="footer-label">FECHA DEL REPORTE</p><p class="footer-value">' + escapeHtml(d.fecha) + '</p></div>' +
            '<div><p class="footer-label">PROYECTO / EDIFICIO</p><p class="footer-value">' + escapeHtml(d.edificio_nombre || "—") + (d.cliente_nombre ? ' · ' + escapeHtml(d.cliente_nombre) : "") + '</p></div>' +
            '<div><p class="footer-label">REPORTE ELABORADO POR</p><p class="footer-value">' + escapeHtml(PORTADA.empresaNombre) + '</p></div>' +
          '</div>' +
          '<div class="portada-tagline">' + escapeHtml(PORTADA.tagline) + ' · ' + escapeHtml(PORTADA.sitioWeb) + '</div>' +
        '</div>' +
      '</div>' +

      '<div class="hoja2">' +
        '<p class="kicker">' + (esSupervision ? 'Reporte de supervisión de mantenimiento' : 'Dictamen técnico de inspección') + '</p>' +
        '<h2>' + escapeHtml(d.equipo_interno || "—") + '</h2>' +
        '<p class="sub">' + escapeHtml(equipoSub) + '</p>' +
        '<dl>' +
          '<div><dt>Cliente</dt><dd>' + escapeHtml(d.cliente_nombre || "—") + '</dd></div>' +
          '<div><dt>Edificio</dt><dd>' + escapeHtml(d.edificio_nombre || "—") + '</dd></div>' +
          '<div><dt>Fecha</dt><dd>' + escapeHtml(d.fecha) + '</dd></div>' +
          '<div><dt>Código</dt><dd>' + escapeHtml(d.codigo) + ' · v1.0</dd></div>' +
        '</dl>' +
      '</div>' +

      '<div class="seccion">' +
        '<p class="kicker">Resumen ejecutivo</p>' +
        '<p class="resumen-parrafo">' + escapeHtml(resumenEjecutivo(d, checklist, esSupervision, nc, criticos)) + '</p>' +
        '<div class="resumen-stats">' +
          '<div class="resumen-stat"><p>' + checklist.length + '</p><p>' + (esSupervision ? "Puntos revisados" : "Puntos verificados") + '</p></div>' +
          '<div class="resumen-stat"><p>' + nc + '</p><p>' + (esSupervision ? "No cumplieron" : "No conformes") + '</p></div>' +
          '<div class="resumen-stat"><p>' + criticos + '</p><p>Hallazgos críticos</p></div>' +
        '</div>' +
        '<div class="resumen-general" style="background:' + cfgGeneral.bg + ';color:' + cfgGeneral.color + ';">' +
          '<p>' + escapeHtml(fraseCalificacion(porcentaje, esSupervision)) + '</p><p>Calificación general del checklist</p>' +
        '</div>' +
      '</div>' +

      '<div class="seccion">' +
        '<p class="kicker">Puntos ' + (esSupervision ? "revisados" : "verificados") + '</p>' +
        '<ul class="checklist-lista">' + checklistHtml + '</ul>' +
      '</div>' +

      '<div class="seccion">' +
        '<p class="kicker">Hallazgos</p>' +
        hallazgosHtml +
      '</div>' +

      (fotosGeneralesHtml ? (
        '<div class="seccion">' +
          '<p class="kicker">Evidencia fotográfica general</p>' +
          '<div class="evidencia-grid">' + fotosGeneralesHtml + '</div>' +
        '</div>'
      ) : "") +

      '<div class="seccion">' +
        '<p class="kicker">Firmas de conformidad</p>' +
        '<div class="firmas-grid">' + firmasHtml + '</div>' +
        '<p class="pie">Documento ' + escapeHtml(d.codigo) + ' · versión 1.0 · generado por ' + escapeHtml(PORTADA.empresaNombre) + '</p>' +
      '</div>' +
    '</div>' +
  '</body></html>';
}
